import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import azureVmsMap from "../../../../JSON/AzureVMsMap.json";
import regionDisplayNames from "../../../../JSON/AzureDisplayNames.json"
import FormatDateTime from "../../../../Functions/FormatDate";
import Spinner from "../../../../Components/Spinner";
import ScaleModal from "./ScaleModal";

const Scaling = ({ metrics, records, costMetrics, fetchRecords }) => {
  const user_id = sessionStorage.getItem("user_id");
  const { project_id, clus_id, link_page } = useParams()

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const [minNodes, setMinNodes] = useState(1);
  const [maxNodes, setMaxNodes] = useState(1);
  const [selectedNodes, setSelectedNodes] = useState(1);
  const [clusterName, setClusterName] = useState(records.k8sname || null)
  const [clusterDesc, setClusterDesc] = useState(records.clus_desc || null)
  const [openScaleModal, setOpenScaleModal] = useState(false)

  const sliderRef = useRef(null);

  useEffect(() => {
    if (!records || !records.vm_size) return;

    const vmConfig = azureVmsMap.find(vm => vm.vm_size === records.vm_size);
    if (vmConfig) {
      setMinNodes(vmConfig.min_nodes);
      setMaxNodes(vmConfig.max_nodes);
      setSelectedNodes(records?.nodes);
    } else {
      setError(true);
      setMessage("VM size not found in configuration.");
    }
  }, [records]);



  const handleDrag = (e) => {
    const slider = sliderRef.current;
    const rect = slider.getBoundingClientRect();
    const percentage = (e.clientX - rect.left) / rect.width;
    const clamped = Math.max(0, Math.min(1, percentage));
    const value = Math.round(clamped * (maxNodes - minNodes) + minNodes);
    setSelectedNodes(value);
  };

  const handleMouseDown = (e) => {
    handleDrag(e);
    window.addEventListener("mousemove", handleDrag);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseUp = () => {
    window.removeEventListener("mousemove", handleDrag);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  const percentage = ((selectedNodes - minNodes) / (maxNodes - minNodes)) * 100;

  return (
    <div className="scaling_container">

      {/* <div className="scale_cluster_desc_info">
        <p className="scale_cluster_desc_info_title">What happens when you scale a cluster in Erioon?</p>
        <p>
          Erioon adds or removes virtual machines (VMs) behind the scenes. These VMs are called nodes and run your applications and processes.<br />If you're scaling up, Erioon provisions new VMs, installs Kubernetes components, and joins them to the cluster.<br />
          If you're scaling down, Erioon safely removes nodes by first moving any running workloads elsewhere.
          The Kubernetes scheduler then starts placing or balancing pods (your containers) across the available nodes.<br />
          This ensures your cluster has the right amount of compute power for your workloads, without downtime.</p>
      </div> */}
      <div className="scale_cluster_title_cont_desc">
        <p className="scale_cluster_title">Scale {clusterName}</p>
        <p className="scale_cluster_desc">{clusterDesc}</p>
      </div>
      <div className="scale_cluster_container">
        {/* <div className="scale_cluster_container_item_first">
          <p className="cluster_card_item">Cluster ID <span className="cluster_card_dynamic_p">{records?._id || "N/A"}</span></p>
          <p className="cluster_card_item">Cluster Name <span className="cluster_card_dynamic_p">{records?.k8sname || "N/A"}</span></p>
          <p className="cluster_card_item">Description <span className="cluster_card_dynamic_p">{records?.clus_desc || "N/A"}</span></p>
          <p className="cluster_card_item">Location <span className="cluster_card_dynamic_p">{regionDisplayNames[records?.selectedRegion]}</span></p>
          <p className="cluster_card_item">Nodes <span className="cluster_card_dynamic_p">{records?.nodes || "N/A"}</span></p>
          <p className="cluster_card_item">OS Type <span className="cluster_card_dynamic_p">{records?.osType || "N/A"}</span></p>
          <p className="cluster_card_item">VM Size <span className="cluster_card_dynamic_p">{records?.vm_size || "N/A"}</span></p>
          <p className="cluster_card_item">Creation date <span className="cluster_card_dynamic_p">{FormatDateTime(records?.timestamp)}</span></p>
          <p className="cluster_card_item">Pool name <span className="cluster_card_dynamic_p">{records?.agent_pool_name || "N/A"}</span></p>
          <p className="cluster_card_item">Status
            <span className="cluster_card_dynamic_p">
              {records?.status == "running" ? (
                <>Running</>
              ) : records?.status == "loading" ? (
                <><Spinner loading={true} /></>

              ) : records?.status == "updating" ? (
                <>Updating<Spinner loading={true} /></>

              ) : (
                <>Failed to create</>
              )}
            </span>
          </p>

        </div> */}
        <div className="scale_cluster_container_item_second">
          <div className="node_scaler_cont">
            <button
              className="scale_btn"
              onClick={() =>
                setSelectedNodes((prev) => Math.min(prev + 1, maxNodes))
              }
              disabled={selectedNodes >= maxNodes}
            >
              <i className="fa-solid fa-plus"></i>
            </button>

            <p className="scale_num">{selectedNodes}</p>

            <button
              className="scale_btn"
              onClick={() =>
                setSelectedNodes((prev) => Math.max(prev - 1, minNodes))
              }
              disabled={selectedNodes <= minNodes}
            >
              <i className="fa-solid fa-minus"></i>
            </button>
          </div>

          <button
            className={`save_btn_db ${selectedNodes == records?.nodes ? "save_btn_db_disabled" : ""}`}
            onClick={() => setOpenScaleModal(true)}
            disabled={selectedNodes === records?.nodes}
          >
            {selectedNodes > records?.nodes
              ? <>Scale up <i className="fa-solid fa-arrow-up"></i></>
              : selectedNodes < records?.nodes
                ? <>Scale down <i className="fa-solid fa-arrow-down"></i></>
                : <>Scale nodes</>}
          </button>
        </div>

      </div>
      <ScaleModal
        show={openScaleModal}
        handleClose={() => setOpenScaleModal(false)}
        selectedNodes={selectedNodes}
        fetchRecords={fetchRecords}
      />
    </div>
  );
};

export default Scaling;
